@if (isVisible) {
  <div [formGroup]="formGroup">
    <form-control-label [question]="componentData" [flow]="flowComponent"></form-control-label>
    @for (item of componentData.config.choices; track item) {
      <div>
        <label>
          <input type="radio"
            [id]="controlId"
            [formControlName]="componentData.key"
            [(ngModel)]="contextValue"
            [value]="item"
            (ngModelChange)="change()" /> {{ item }}
          </label>
        </div>
      }
    </div>
  }
